import api from '@/api'
import dayjs from 'dayjs'
import _ from 'lodash'

export default {
  state: {
    range: {
      start: dayjs().format('YYYY-MM-DD'),
      end: dayjs().add(3, 'month').format('YYYY-MM-DD')
    },
    tasks: [],
    presentTasks: [],
    todayTasks: [],
    tomorrowTasks: [],
    futureTasks: []
  },
  mutations: {
    LOAD_TASKS(state, list) {
      state.tasks = list
      console.debug(`LOAD_TASKS`, list)
    },
    SET_TASKS_RANGE(state, range) {
      state.range = range
    },
    LOAD_PRESENT_TASKS(state, list) {
      state.presentTasks = list
    },
    LOAD_TODAY_TASKS(state, list) {
      state.todayTasks = list
    },
    LOAD_TOMORROW_TASKS(state, list) {
      state.tomorrowTasks = list
    },
    LOAD_FUTURE_TASKS(state, list) {
      state.futureTasks = list
    }
  },
  actions: {
    async loadTasks({ commit, state, dispatch }, options) {
      // commit('LOAD_TASKS', [])
      const start = options?.start ?? state.range.start
      const end = options?.end ?? state.range.end

      commit('SET_TASKS_RANGE', { start, end })
      try {
        const response = await api.newsdesk.searchTasks(
          {
            start_date: start,
            endDate: end,
            limit: 2500
          },
          options?.skipCache ?? false
        )
        const list = response?.data ?? []
        commit('LOAD_TASKS', list)
      } catch (error) {
        console.error('Could not load tasks', error)
      }
    },
    setTasksRange({ commit, state }, range) {
      commit('SET_TASKS_RANGE', range)
    },
    async loadPresentTasks({ commit, state, dispatch, rootGetters }, options) {
      // commit('LOAD_PRESENT_TASKS', [])
      const startFrom = dayjs().tz(rootGetters.currentTimezone).format('YYYY-MM-DD')
      try {
        const response = await api.newsdesk.searchTasks(
          {
            start_date: startFrom,
            limit: 2500
          },
          options?.skipCache ?? false
        )

        let tasks = response?.data ?? []
        // tasks = tasks.filter((t) => t.s_story_approved !== 'Bust')

        commit('LOAD_PRESENT_TASKS', tasks)

        await dispatch('loadTodayTasks')
        await dispatch('loadTomorrowTasks')
        await dispatch('loadFutureTasks')
      } catch (error) {
        console.error('Could not load tasks', error)
      }
    },
    async loadTodayTasks({ commit, state, rootGetters }) {
      // commit('LOAD_TODAY_TASKS', [])
      const ymd = dayjs().tz(rootGetters.currentTimezone).format('YYYY-MM-DD')

      let presentTasks = _.cloneDeep(state.presentTasks)
      let todayTasks = await Promise.all(presentTasks.filter((t) => t.start_date == ymd))

      commit('LOAD_TODAY_TASKS', todayTasks)
    },
    async loadTomorrowTasks({ commit, state, rootGetters }) {
      // commit('LOAD_TOMORROW_TASKS', [])
      const tomorrow = dayjs().add(1, 'day').tz(rootGetters.currentTimezone).format('YYYY-MM-DD')

      let presentTasks = _.cloneDeep(state.presentTasks)
      let tomorrowTasks = await Promise.all(
        presentTasks.filter((t) => t.start_date == tomorrow)
        // .map(async (task) => {
        //   let taskStory = await (_.head(task.story) ?? api.newsdesk.getStoryWithDetails(task.story_id)) // temp fix for missing story data in task data
        //   // task.story_row_id = taskStory.row_id
        //   task.storyTitle = taskStory.title
        //   task.story = JSON.parse(JSON.stringify(taskStory))
        //   return task
        // })
      )
      commit('LOAD_TOMORROW_TASKS', tomorrowTasks)
    },
    async loadFutureTasks({ commit, state, rootGetters }) {
      // commit('LOAD_FUTURE_TASKS', [])

      const ymd = dayjs().tz(rootGetters.currentTimezone).format('YYYY-MM-DD')

      let presentTasks = _.cloneDeep(state.presentTasks)
      let futureTasks = await Promise.all(
        presentTasks
          .filter((t) => t.start_date != ymd)
          .map(async (task) => {
            // let taskStory = await (_.head(task.story) ?? api.newsdesk.getStoryWithDetails(task.story_id)) // temp fix for missing story data in task data
            // task.story_date_label = task.start_date ?? 'TBD'
            // task.story_date = taskStory.story_date
            task.originalTitle = task.title
            task.title = `${task.title}`.toUpperCase() + ` - ${task.story?.title}`
            task.class = 'task'
            task.is_task = true
            // task.story = JSON.parse(JSON.stringify(taskStory))
            return task
          })
      )

      commit('LOAD_FUTURE_TASKS', futureTasks)
    }
  },
  getters: {
    tasks(state) {
      return state.tasks
    },
    tasksRange(state) {
      return state.range
    },
    todayTasks(state) {
      return state.todayTasks
    },
    tomorrowTasks(state) {
      return state.tomorrowTasks
    },
    futureTasks(state) {
      return state.futureTasks
    }
  }
}
